import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'polylearn-toeic-service-redirect',
  template: ''
})
export class ToeicServiceRedirectComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    this.router.navigateByUrl('/information-importante', { replaceUrl: true });
  }
}
